import React, { createContext, useContext } from "react";

export type ContentAreaSize = "xs" | "sm" | "md";

const ContentAreaSizeContext = createContext<ContentAreaSize>("md");

export const useContentAreaSize = () => useContext(ContentAreaSizeContext);

export const ContentAreaSizeProvider: React.FC<{
  size: ContentAreaSize;
  children: React.ReactNode;
}> = ({ size, children }) => (
  <ContentAreaSizeContext.Provider value={size}>{children}</ContentAreaSizeContext.Provider>
);
